import { React } from "react"
import mayaTnC from "../../assets/mayaTnCText.txt"
import mayaPrivacy from "../../assets/mayaPrivacyText.txt"
import CustomFooter from "./CustomFooter"

function GamingFooter({ id, rrn, opt, redirect }) {
  return (
    <CustomFooter
      id={id}
      rrn={rrn}
      opt={opt}
      redirect={redirect}
      privacyText={mayaPrivacy}
      tncText={mayaTnC}
    />
  )
}

export default GamingFooter
